export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/science_fiction_fantasy.bd0e99d.svg";